<template>
  <div class="lian_jie">
    <div class="center">
      <div class="line">
        <div class="three-column-list">
          <!-- 添加产品中心 -->
          <div class="column">
            <a class="text">{{ $t("system.home.lianjie.text_a") }}</a>
            <!-- 产品中心部分 -->
            <ul class="category-list">
              <li v-for="category in productList" :key="category.id">
                <span class="category-title">
                  {{
                    $i18n.locale === "zh-cn"
                      ? category.translations["zh-cn"].cname
                      : category.translations["en"].cname
                  }}
                </span>
                <ul
                  v-if="category.children && category.children.length"
                  class="sub-category"
                >
                  <li
                    v-for="subCategory in category.children"
                    :key="subCategory.id"
                  >
                    <!-- Level 2: 子系统/菜单 -->
                    <span
                      class="sub-category-link"
                      @click="handleLevel2Click(subCategory, category.id)"
                    >
                      {{
                        $i18n.locale === "zh-cn"
                          ? subCategory.translations?.["zh-cn"]?.cname
                          : subCategory.translations?.["en"]?.cname
                      }}
                    </span>
                    <!-- Level 3 -->
                    <!-- <template
                      v-if="subCategory.children && subCategory.children.length"
                    >
                      <ul class="sub-category">
                        <li
                          v-for="child in subCategory.children"
                          :key="child.id"
                        >
                          <span
                            class="sub-category-link"
                            @click="
                              handleLevel3Click(child, category.id, subCategory)
                            "
                          >
                            {{
                              $i18n.locale === "zh-cn"
                                ? child.translations?.["zh-cn"]?.cname
                                : child.translations?.["en"]?.cname
                            }}
                          </span>
                          <template
                            v-if="child.children && child.children.length"
                          >
                            <ul class="sub-category">
                              <li
                                v-for="grandChild in child.children"
                                :key="grandChild.id"
                              >
                                <span
                                  class="sub-category-link"
                                  @click="
                                    handleLevel4Click(grandChild, category.id)
                                  "
                                >
                                  {{
                                    $i18n.locale === "zh-cn"
                                      ? grandChild.translations?.["zh-cn"]
                                          ?.cname
                                      : grandChild.translations?.["en"]?.cname
                                  }}
                                </span>
                              </li>
                            </ul>
                          </template>
                        </li>
                      </ul>
                    </template> -->
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!-- 添加新闻中心 -->
          <div class="column">
            <router-link class="text" to="/news/new">{{
              $t("system.home.lianjie.text_news")
            }}</router-link>
            <ul>
              <li v-for="news in newsList" :key="news.id">
                <router-link :to="`/news/newpage/${news.id}`">
                  {{ $i18n.locale === "zh-cn" ? news.title : news.titleEn }}
                </router-link>
              </li>
            </ul>
          </div>

          <!-- 原有的关于我们 -->
          <div class="column">
            <a class="text">{{ $t("system.home.lianjie.text_b") }}</a>
            <ul>
              <li>
                <router-link to="/about/company">{{
                  $t("system.home.lianjie.a_j")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/quality">{{
                  $t("system.home.lianjie.a_k")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/Efficient">{{
                  $t("system.home.lianjie.a_l")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/digital">{{
                  $t("system.home.lianjie.a_m")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/marketing">{{
                  $t("system.home.lianjie.a_n")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/partner">{{
                  $t("system.home.lianjie.a_o")
                }}</router-link>
              </li>
              <li>
                <router-link to="/about/social">{{
                  $t("system.home.lianjie.a_p")
                }}</router-link>
              </li>
            </ul>
          </div>

          <!-- 原有的联系我们 -->
          <div class="column">
            <router-link class="text" to="/contact/ContactWay">{{
              $t("system.home.lianjie.text_c")
            }}</router-link>
            <ul>
              <li>
                <router-link to="/contact/ContactWay">{{
                  $t("system.home.lianjie.a_q")
                }}</router-link>
              </li>
              <!-- <li>
                <router-link to="/contact/Register">{{
                  $t("system.home.lianjie.a_r")
                }}</router-link>
              </li> -->
            </ul>
          </div>
          <div class="column" style="width: 30%">
            <span class="text">{{ $t("system.home.lianjie.a_u") }}</span>

            <FootMessage />
          </div>
        </div>
        <!-- 社交影音 -->
        <!-- <Icon></Icon> -->
      </div>
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script setup lang="ts">
import Footer from "./Footer.vue";
import Icon from "./Icon.vue";
import FootMessage from "./FootMessage.vue";
import { useRouter } from "vue-router";
import { ref, onMounted } from "vue";
import axios from "./../../../utils/axios";
import { useBreadcrumbStore } from "@/stores/breadcrumb";
import { useI18n } from "vue-i18n";
const router = useRouter();
const newsList = ref([]);
const productList = ref([]);
const breadcrumbStore = useBreadcrumbStore();
const { locale } = useI18n();
onMounted(() => {
  getNewsList();
  getProductCategories();
});
const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
};
const getNewsList = async () => {
  try {
    const response = await axios.get("/framework/news/list", {
      params: {
        pageSize: 5,
        num: 1,
      },
    });
    newsList.value = response.records;
  } catch (error) {
    console.error("获取新闻列表失败：", error);
  }
};
// 获取产品分类列表
const getProductCategories = async () => {
  try {
    const response = await axios.get("/framework/product/list/tree");
    productList.value = response || [];
  } catch (error) {
    console.error("获取产品分类失败：", error);
  }
};

// 判断是否是子系统
const isSubSystem = (category: any) => {
  return (
    category.children &&
    category.children.some(
      (child: any) => child.children && child.children.length > 0
    )
  );
};

// 处理二级点击（子系统/菜单）
const handleLevel2Click = (category: any, parentId: string) => {
  const breadcrumbs = [
    {
      title: getTranslatedText(category.translations, "cname"),
      translations: category.translations,
    },
  ];
  breadcrumbStore.setBreadcrumbs(breadcrumbs);

  router.push({
      path: "/home/product-system",
      query: {
        // 如果是子系统，传 systemId，否则传 menuId
        ...(category.hasSystem === 1
          ? { systemId: category.id }
          : { menuId: category.id }),
        parentId: category,
        // translations: JSON.stringify(menuItem.translations),
      },
    });
};

// 处理三级点击（无子系统情况下的分类）
const handleLevel3Click = (
  category: any,
  parentId: string,
  parentCategory: any
) => {
  const breadcrumbs = [
    {
      title: getTranslatedText(parentCategory.translations, "cname"),
      translations: parentCategory.translations,
    },
    {
      title: getTranslatedText(category.translations, "cname"),
      translations: category.translations,
    },
  ];
  breadcrumbStore.setBreadcrumbs(breadcrumbs);
  if (category.hasSystem !== 1) {
    router.push({
      path: "/home/productlist",
      query: { cid: category.id },
    });
  }
};

// 处理四级点击（子系统下的分类）
const handleLevel4Click = (category: any, parentId: string) => {
  // 查找所有父级菜单
  const productCenter = productList.value.find((item) =>
    item.children?.some((l2) =>
      l2.children?.some((l3) =>
        l3.children?.some((l4) => l4.id === category.id)
      )
    )
  );

  const level2 = productCenter?.children?.find((item) =>
    item.children?.some((l3) =>
      l3.children?.some((l4) => l4.id === category.id)
    )
  );

  const level3 = level2?.children?.find((item) =>
    item.children?.some((l4) => l4.id === category.id)
  );

  const breadcrumbs = [
    {
      title: getTranslatedText(level2?.translations, "cname"),
      translations: level2?.translations,
    },
    {
      title: getTranslatedText(level3?.translations, "cname"),
      translations: level3?.translations,
    },
    {
      title: getTranslatedText(category.translations, "cname"),
      translations: category.translations,
    },
  ];
  breadcrumbStore.setBreadcrumbs(breadcrumbs);

  router.push({
    path: "/home/productlist",
    query: { cid: category.id },
  });
};
</script>

<style lang="scss" scoped>
// 保留基础布局样式
.lian_jie {
  width: 100%;
  background: #f8f8f8;
  background-size: contain;
  z-index: 99;
}
.center {
  width: 100%;
  padding: 60px 0;
  padding: 70px 0 70px 0;
}
.line {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 1400px;
  height: 228px;
  margin: 0 auto;
  padding: 0 15px;
}
.three-column-list {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  width: 100%;
}

.column {
  margin-right: 20px;

  &:last-child {
    margin-right: 0;
  }
  // 标题样式
  .text {
    font-weight: 600;
    font-size: 20px;
    cursor: pointer;
    color: #004080;
    margin-bottom: 15px;
    display: inline-block;
    transition: all 0.3s ease;

    &:hover {
      opacity: 0.8;
      transform: translateX(5px);
    }
  }
  .disabled-link {
    font-size: 13px;
    color: #999;
    cursor: not-allowed;
  }
  // 列表通用样式
  > ul,
  .category-list {
    // 只针对直接子级的ul和category-list
    max-height: 200px;
    overflow-y: auto;
    padding-right: 10px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ddd;
      border-radius: 2px;
    }

    &::-webkit-scrollbar-track {
      background: #f5f5f5;
    }

    li {
      margin-bottom: 10px;
      list-style: none;

      a {
        font-size: 14px;
        font-weight: 400;
        color: #333;
        transition: all 0.3s ease;
        display: inline-block;
        text-decoration: none;

        &:hover {
          color: #004080;
          transform: translateX(5px);
          font-weight: 500;
        }
      }
    }
  }

  // 产品中心多级分类样式
  .category-list {
    li {
      margin-bottom: 15px;

      .category-title {
        font-weight: 500;
        color: #004080;
        display: block;
        margin-bottom: 8px;
        font-size: 15px;
      }

      .sub-category {
        padding-left: 15px;
        margin-top: 5px;

        li {
          margin-bottom: 8px;

          .sub-category-link {
            cursor: pointer;
            font-size: 13px;
            color: #666;
            text-decoration: none;
            transition: all 0.3s ease;
            display: block;

            &:hover {
              color: #004080;
              transform: translateX(5px);
            }
          }
        }
      }
    }
  }
  // 二级和三级分类不需要滚动条
  .sub-category,
  .third-category {
    max-height: none;
    overflow-y: visible;
    padding-right: 0;
  }
}

// 添加可点击的样式
.sub-category-link {
  cursor: pointer;
  font-size: 13px;
  color: #666;
  text-decoration: none;
  transition: all 0.3s ease;
  display: block;

  &:hover {
    color: #004080;
    transform: translateX(5px);
  }
}
</style>
